// Central config for the 10 field-activity types.
// Each type has: key, label, icon (lucide name), color hex, roles allowed (null = all),
// default visit_type label saved in db.

export const ACTIVITY_TYPES = [
  { key: "visite_standard", label: "Visite corner standard", icon: "Store", color: "#3b82f6",
    visit_type: "Visite corner standard",
    desc: "Contrôle rapide, observation terrain." },
  { key: "rdv_magasin", label: "Rendez-vous magasin", icon: "Handshake", color: "#8b5cf6",
    visit_type: "Rendez-vous magasin",
    desc: "Point avec la direction du magasin." },
  { key: "demande_rdv", label: "Demande de RDV", icon: "CalendarPlus", color: "#a855f7",
    visit_type: "Demande de RDV",
    desc: "Demande de rendez-vous auprès d'un magasin (pré-planification)." },
  { key: "formation_hygiene", label: "Formation hygiène", icon: "SprayCan", color: "#06b6d4",
    visit_type: "Formation hygiène",
    desc: "Formation à un collaborateur (signature obligatoire)." },
  { key: "formation_hygiene_rt", label: "Formation hygiène (RT/MM)", icon: "GraduationCap", color: "#0ea5e9",
    visit_type: "Formation hygiène RT/MM", roles: ["rt", "mm", "director", "admin"],
    desc: "Compte rendu d'une formation ou d'un suivi hygiène." },
  { key: "point_equipe", label: "Point équipe", icon: "Users", color: "#f59e0b",
    visit_type: "Point équipe",
    desc: "Réunion, entrevue, performance, échange." },
  { key: "audit_corner", label: "Audit corner / Hygiène", icon: "ClipboardCheck", color: "#10b981",
    visit_type: "Audit",
    desc: "Trame complète, calcul auto du taux de conformité." },
  { key: "formation_technique", label: "Formation / Suivi technique", icon: "ChefHat", color: "#ec4899",
    visit_type: "Formation technique", roles: ["rt", "mm", "director", "admin", "manager"],
    desc: "Sushi, Découpe, Wok, Nettoyage, Commande, Inventaire…" },
  { key: "formation_methode", label: "Formation méthode / process", icon: "BookOpen", color: "#6366f1",
    visit_type: "Formation méthode",
    desc: "Rappel des méthodes et process." },
  { key: "entretien_rh", label: "Entretien RH", icon: "UserCog", color: "#ef4444",
    visit_type: "Entretien RH",
    desc: "Embauche, annuel, disciplinaire, rappel, avertissement…" },
  { key: "maintenance", label: "Visite maintenance", icon: "Wrench", color: "#64748b",
    visit_type: "Maintenance",
    desc: "Nettoyage, contrôle, réparation, dépannage." },
];

export const RDV_INTERLOCUTEURS = ["Adhérent(e)", "Directeur(trice)", "Adjoint(e)", "Resp qualité", "Resp Rayon", "Directeur(trice) général"];
export const RDV_OBJETS = ["Suivi corner", "Renouvellement contrat", "Business Review", "Gestion de problématique"];

export const TECH_TYPES = ["Sushi", "Découpe", "Wok", "Nettoyage", "Passage commande", "Inventaire"];

export const ENTRETIEN_TYPES = [
  "Embauche collaborateur", "Entretien annuel", "Entretien disciplinaire",
  "Entretien de rappel", "Remise d'avertissement", "Remise de mise à pied", "Rupture conventionnelle", "Autre",
];
export const ENTRETIEN_LIEUX = ["Bureau", "Salle magasin", "Corner", "Restaurant/Café", "Coworking", "Autre"];

export const MAINTENANCE_ACTIONS = [
  "Maintenance vitrine", "Nettoyage condenseur vitrine", "Nettoyage vitrine",
  "Changement petit électro", "Dépannage SATO ou tablette", "Petite réparation", "Autre",
];

// Default audit templates (professional / streamlined — user will refine later)
export const AUDIT_TEMPLATE_CORNER = [
  { cat: "Vitrine & merchandising", items: [
    "Vitrine propre et rangée",
    "Températures vitrine conformes (relevé du jour)",
    "Étiquettes prix visibles et à jour",
    "Assortiment cohérent, fond de vitrine complet",
    "Rotation FIFO respectée, aucun produit périmé",
    "PLV & signalétique en place",
  ]},
  { cat: "Poste de travail", items: [
    "Poste propre et organisé",
    "Réserve rangée",
    "Tablette / SATO fonctionnelle",
    "Fiches recettes disponibles",
  ]},
  { cat: "Équipe", items: [
    "Tenue de travail portée correctement",
    "Hygiène des mains",
    "Communication client fluide",
  ]},
  { cat: "Qualité produit", items: [
    "Aspect / dressage conforme",
    "DLC respectées",
    "Quantités et grammages respectés",
  ]},
];

// Real Wasabi audit template — actual chapters from Grille d'Audit interne
export const AUDIT_TEMPLATE_HYGIENE = [
  { cat: "CHAP 1 — Réception", items: [
    "111. Respect de la procédure de contrôle réception (fréquence, méthode, enregistrement, conclusion)",
    "1016. Respect du TACT (Temps, Action mécanique, Concentration, Température)",
  ]},
  { cat: "CHAP 2 — Stockage", items: [
    "212. Respect des conditions d'élimination des emballages / cartons",
    "213. Respect de la sectorisation par catégorie des produits stockés",
    "214. Stockage des produits hors sol",
    "218. Protection satisfaisante des produits",
    "220. Respect des DLC",
    "221. Respect des DDM",
    "225. Maîtrise des T° des enceintes frigorifiques positives",
    "227. Maîtrise des T° des enceintes frigorifiques négatives",
  ]},
  { cat: "CHAP 3 — Prétraitement", items: [
    "313. Respect des bonnes pratiques de décongélation",
    "314. Respect du protocole de décontamination des végétaux",
    "319. Maîtrise de la traçabilité produits déconditionnés / décongelés (étiquette d'origine…)",
    "320. Respect des durées de vie maxi des matières 1ères déconditionnées / décongelées",
  ]},
  { cat: "CHAP 4 — Préparation froide", items: [
    "417. Conformité des T°C des préparations froides",
    "418. Température relevée des préparations froides",
    "419. Identification et respect des durées de vie maxi des encours / produits finis",
  ]},
  { cat: "CHAP 5 — Préparation chaude", items: [
    "515. Respect des modalités de refroidissement (cellule, eau froide, chambre froide)",
    "516. Respect de la procédure de contrôle refroidissement (fréquence, méthode, enregistrement)",
    "529. Connaissance et respect de l'instruction de fabrication du riz vinaigré",
  ]},
  { cat: "CHAP 6 — Distribution / Libre-service", items: [
    "617. Conformité des T° des meubles de distribution en froid",
    "618. T° de présentation compatible pour les préparations froides",
    "619. Température relevée des préparations froides",
    "637. Respect des limites de chargement des meubles",
    "638. Respect des DLC / DVM définies pour les produits à la vente",
    "639. Respect des DDM des produits à la vente",
    "640. Conformité de l'étiquetage des produits vendus en LS",
  ]},
  { cat: "CHAP 8 — Hygiène du personnel", items: [
    "811. Tenue de travail conforme, propre et adaptée au poste",
    "813. Lave-mains conformes, approvisionnés et accessibles",
    "814. Respect de la procédure de lavage des mains",
    "815. Protection satisfaisante des plaies et infections",
    "816. Comportement adapté contre les risques de contamination",
    "820. Gestion du linge propre/sale et tenues à usage unique",
    "821. Conformité de l'armoire à pharmacie",
  ]},
  { cat: "CHAP 9 — Organisation générale & maintenance", items: [
    "911. Absence de dégradation des locaux et équipements",
    "914. Absence de traces de ravageurs et nuisibles",
    "921. Maîtrise des temps d'attente hors froid",
    "923. Séparation satisfaisante des produits bruts et cuits",
  ]},
  { cat: "CHAP 10 — Entretien des locaux et matériels", items: [
    "1011. Présence et respect du planning de nettoyage",
    "1012. Suivi du respect du planning de nettoyage",
    "1021. Propreté et rangement des locaux non-alimentaires (réception, communs)",
    "1023. Propreté et rangement des vestiaires et sanitaires",
    "1031. Propreté et rangement des matériels hors contact aliments",
    "1032. Propreté et rangement des matériels au contact aliments",
  ]},
  { cat: "CHAP 11 — Système documentaire", items: [
    "1124. Classement et archivage des attestations de formation",
    "1127. Conformité du test de traçabilité",
  ]},
];

// Formation hygiène & questionnaire — documents & languages
export const HYGIENE_DOCS = {
  formation: {
    fr: "https://customer-assets-gfyr7b9c.emergentagent.net/job_orbit-sync-6/artifacts/mfb3izw4_Formation%20hygi%C3%A8ne%20pr%C3%A9pa%20Wasabi%202026.pdf",
    en: null, th: null, vi: null,
  },
  questionnaire: {
    fr: "https://customer-assets-gfyr7b9c.emergentagent.net/job_orbit-sync-6/artifacts/w33n0vrk_Questionnaire%20fin%20de%20formation%20-%20AURILLAC%20-%202026-04-13T114205_333Z%20Girard%20Yoann.pdf",
    en: null, th: null, vi: null,
  },
};
export const HYGIENE_LANGS = [
  { v: "fr", label: "Français", flag: "🇫🇷" },
  { v: "en", label: "English", flag: "🇬🇧" },
  { v: "th", label: "ภาษาไทย", flag: "🇹🇭" },
  { v: "vi", label: "Tiếng Việt", flag: "🇻🇳" },
];

export const SATISFACTION_OPTS = [
  { v: "satisfait", label: "Satisfait", color: "emerald" },
  { v: "mitige", label: "Mitigé", color: "amber" },
  { v: "insatisfait", label: "Insatisfait", color: "rose" },
];

export const RESULTAT_OPTS = [
  { v: "maitrise", label: "Maîtrisé", color: "emerald" },
  { v: "a_suivre", label: "À suivre", color: "amber" },
  { v: "non_maitrise", label: "Non maîtrisé", color: "rose" },
];
